export default __webpack_public_path__ + "static/media/kcNbilly.c9554f36.jpeg";